import React from "react"
import { Helmet } from "react-helmet"
import og from "../image/og.png"

export default function SEO() {
  return (
    <Helmet>
      {/* <!-- Primary Meta Tags --> */}
      <title>こちらは旧ホームページです - Code With Me!</title>
      <meta name="title" content="こちらは旧ホームページです - Code With Me!" />
      <meta
        name="description"
        content="宮崎県都城市のプログラミングスクールです。サイト作成、Webアプリケーション開発、データ分析を学びます。"
      />
      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://codewithme.net/" />
      <meta
        property="og:title"
        content="宮崎県都城市のプログラミングスクール - Code With Me!"
      />
      <meta
        property="og:description"
        content="宮崎県都城市のプログラミングスクールです。サイト作成、Webアプリケーション開発、データ分析を学びます。"
      />
      <meta property="og:image" content={"https://codewithme.net" + og} />
      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://codewithme.net/" />
      <meta
        property="twitter:title"
        content="宮崎県都城市のプログラミングスクール - Code With Me!"
      />
      <meta
        property="twitter:description"
        content="宮崎県都城市のプログラミングスクールです。サイト作成、Webアプリケーション開発、データ分析を学びます。"
      />
      <meta property="twitter:image" content={"https://codewithme.net" + og} />
      {/* <!-- add --> */}
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />

      <body className="leading-normal tracking-normal text-white" />
    </Helmet>
  )
}
